import React, { useState, useEffect } from 'react';
import { X, Cookie, Check } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('kadmiai_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('kadmiai_cookie_consent', JSON.stringify({ necessary: true, analytics: true, marketing: true, timestamp: new Date().toISOString() }));
    setIsVisible(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('kadmiai_cookie_consent', JSON.stringify({ necessary: true, analytics: false, marketing: false, timestamp: new Date().toISOString() }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-in-up">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-border p-6">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <Cookie className="w-6 h-6 text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-foreground mb-2">{t('cookie.title', 'Nous respectons votre vie privée')}</h3>
            <p className="text-sm text-muted-foreground mb-4">{t('cookie.text', 'Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic et personnaliser le contenu. Vous pouvez accepter tous les cookies ou seulement les essentiels.')}</p>
            <div className="flex flex-wrap gap-3">
              <Button onClick={acceptAll} size="sm" className="rounded-full"><Check className="w-4 h-4 mr-2" />{t('cookie.accept_all', 'Tout accepter')}</Button>
              <Button onClick={acceptNecessary} variant="outline" size="sm" className="rounded-full">{t('cookie.essential_only', 'Essentiels uniquement')}</Button>
              <a href="/privacy" className="text-sm text-muted-foreground hover:text-primary underline self-center">{t('cookie.learn_more', 'En savoir plus')}</a>
            </div>
          </div>
          <button onClick={acceptNecessary} className="p-2 hover:bg-slate-100 rounded-lg transition-colors" aria-label="Close"><X className="w-5 h-5 text-muted-foreground" /></button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
